import { Component, inject, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SonaUsageFacade } from '@sona/angular-auth-api';
import { useI18n } from '@sona/angular-util-common';
import { useDialog } from '@spartan-ng/ui-dialog-helm';
import { toast } from 'ngx-sonner';

import { PaymentsFacade } from '../../../src/lib/services/payments-facade';
import { SonaEndTrialDialog } from '../dialogs/end-trial-dialog.ng';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'button[sonaEndTrialButton]',
    standalone: true,
    imports: [TranslatePipe],
    template: ` {{ 'PAYMENTS.COMPONENT.END_TRIAL.LABEL' | translate }} `,
    host: {
        '(click)': 'openDialog($event)'
    }
})
export class SonaEndTrialMenuItemComponent {
    private readonly _paymentsFacade = inject(PaymentsFacade);
    protected readonly _usageFacade = inject(SonaUsageFacade);
    protected readonly _i18n = useI18n();
    protected readonly _endTrialButtonDisabled = signal(false);
    private readonly _dialog = useDialog();

    openDialog(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();

        this._dialog.open(SonaEndTrialDialog, {}, () => this.endTrial());
    }

    async endTrial() {
        this._endTrialButtonDisabled.set(true);

        try {
            await this._paymentsFacade.endTrial();
            toast.success(this._i18n().t('PAYMENTS.COMPONENT.UPGRADE_BUTTON.END_TRIAL.FEEDBACK.SUCCESS'));

            this._usageFacade.updateUsage();

            setTimeout(async () => {
                this._usageFacade.updateUsage();
                this._endTrialButtonDisabled.set(false);
            }, 10_000);
        } catch (e) {
            this._usageFacade.updateUsage();
            toast.error(this._i18n().t('PAYMENTS.COMPONENT.UPGRADE_BUTTON.END_TRIAL.FEEDBACK.ERROR'));
            this._endTrialButtonDisabled.set(false);
        }
    }
}
